import React, { useEffect, useState } from "react";
import './orderTrackingLocation.css';
function OrderTrackingLocationUI({locationHistoryData,orderLocationData}) {
    const [completedProcess, setCompletedProcess] = useState(0);
  
    useEffect(() => {
      if (completedProcess === 0) {
        const timeout = setTimeout(() => {
          setCompletedProcess(1);
        }, 3000);
  
        return () => clearTimeout(timeout);
      }
    }, [completedProcess]);
    useEffect(() => {
      if (completedProcess === 1) {
        const timeout = setTimeout(() => {
          setCompletedProcess(2);
        }, 3000);
  
        return () => clearTimeout(timeout);
      }
    }, [completedProcess]);
  
    useEffect(() => {
      if (completedProcess === 2) {
        const timeout = setTimeout(() => {
          setCompletedProcess(3);
        }, 3000);
  
        return () => clearTimeout(timeout);
      }
    }, [completedProcess]);
  
    useEffect(() => {
      const adjustLineHeight = () => {
        const statuses = document.querySelectorAll(".order-track-status-line");
        statuses.forEach((status) => {
          const parent = status.closest(".order-track-step");
          const height = parent.offsetHeight - 20;
          status.style.height = `${height}px`;
        });
      };
  
      adjustLineHeight();
  
      window.addEventListener("resize", adjustLineHeight);
      return () => {
        window.removeEventListener("resize", adjustLineHeight);
      };
    }, []);
  
    return (
      <div
        style={{
          backgroundColor: "#F6F6F6",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            paddingTop: "20px",
          }}
        >
          
          <div
            style={{
              backgroundColor: "#FFFFFF",
              width: "100%",
              height: "auto",
              borderRadius: "20px",
            }}
          >
            {/* Third section content */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "40px",
              }}
            >
              <p style={{ fontSize: "20px" }}>{orderLocationData.orderId}</p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <i
                  className="fa-regular fa-copy"
                  style={{ fontSize: "20px", color: "#A9A9A9" }}
                ></i>
                <i
                  className="fa-solid fa-phone-volume"
                  style={{ fontSize: "20px", color: "#A9A9A9" }}
                ></i>
              </div>
            </div>
            <div className="order-track" style={{ paddingLeft: "40px" }}>
             {locationHistoryData?.map((location,index)=>(
                <div className="order-track-step">
                <div className="order-track-status">
                  <div
                    style={{
                      padding: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        completedProcess >= 1 ? "orange" : "lightgray",
                    }}
                  >
                    <i className="fa-solid fa-check"></i>
                  </div>
                  <span
                    className="order-track-status-line"
                    style={{
                      backgroundColor:
                        completedProcess >= 1 ? "orange" : "lightgray",
                    }}
                  ></span>
                </div>
                <div className="order-track-text">
                  <p
                    className="order-track-text-stat"
                    style={{
                      color: "#3F3F3F",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    {location.enumStatus}
                    <span style={{ fontWeight: "normal",marginLeft:"10px" }}>{location.time}</span>
                  </p>
                  {<span
                    className="order-track-text-sub"
                    style={{ fontSize: "18px" }}
                  >
                    Your order has arrived in {location.location}
                  </span>}
                </div>
              </div>
             )) }
              {/* <div className="order-track-step">
                <div className="order-track-status">
                  <div
                    style={{
                      padding: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        completedProcess >= 2 ? "orange" : "lightgray",
                    }}
                  >
                    <i className="fa-regular fa-user"></i>
                  </div>
                  <span
                    className="order-track-status-line"
                    style={{
                      backgroundColor:
                        completedProcess >= 2 ? "orange" : "lightgray",
                    }}
                  ></span>
                </div>
                <div className="order-track-text">
                  <p
                    className="order-track-text-stat"
                    style={{
                      color: "#3F3F3F",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    Доставляется{" "}
                    <span style={{ fontWeight: "normal" }}>02-27 15:44</span>
                  </p>
                </div>
              </div>
              <div className="order-track-step">
                <div className="order-track-status">
                  <div
                    style={{
                      padding: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        completedProcess >= 3 ? "orange" : "lightgray",
                      color: "gray",
                    }}
                  >
                    <i className="fas fa-truck"></i>
                  </div>
                  <span
                    className="order-track-status-line"
                    style={{
                      backgroundColor:
                        completedProcess >= 3 ? "orange" : "lightgray",
                    }}
                  ></span>
                </div>
                <div className="order-track-text">
                  <p
                    className="order-track-text-stat"
                    style={{
                      color: "#3F3F3F",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    Прибыл в "название города"{" "}
                    <span style={{ fontWeight: "normal" }}>02-29 15:44</span>
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      gap: "20px",
                      marginTop: "10px",
                    }}
                  >
                    <p style={{ fontSize: "18px", fontWeight: "normal" }}>
                      Прибыл в Астану 02-27 15:44
                    </p>
                    <p style={{ fontSize: "18px", fontWeight: "normal" }}>
                      Прибыл в Урумчи 02-27 15:44
                    </p>
                    <p style={{ fontSize: "18px", fontWeight: "normal" }}>
                      Отправлено в "название города" 02-27 15:44
                    </p>
                    <p style={{ fontSize: "18px", fontWeight: "normal" }}>
                      Транзитный склад 02-27 15:44
                    </p>
                    <p style={{ fontSize: "18px", fontWeight: "normal" }}>
                      Прибыл в Гуанчжоу 02-27 15:44
                    </p>
                  </div>
                </div>
              </div>
              <div className="order-track-step">
                <div className="order-track-status">
                  <div
                    style={{
                      padding: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        completedProcess >= 3 ? "orange" : "lightgray",
                      color: "gray",
                    }}
                  >
                    <i className="fas fa-truck"></i>
                  </div>
                  <span
                    className="order-track-status-line"
                    style={{
                      backgroundColor:
                        completedProcess >= 3 ? "orange" : "lightgray",
                    }}
                  ></span>
                </div>
                <div className="order-track-text">
                  <p
                    className="order-track-text-stat"
                    style={{
                      color: "#3F3F3F",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    Отправлено в Гуанчжоу{" "}
                    <span style={{ fontWeight: "normal" }}>02-29 15:44</span>
                  </p>
                </div>
              </div>
              <div className="order-track-step">
                <div className="order-track-status">
                  <div
                    style={{
                      padding: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        completedProcess >= 3 ? "orange" : "lightgray",
                      color: "gray",
                    }}
                  >
                    <i
                      className="fa-solid fa-clipboard-list"
                      style={{
                        backgroundColor:
                          completedProcess >= 3 ? "orange" : "lightgray",
                      }}
                    ></i>
                  </div>
                  <span className="order-track-status-line"></span>
                </div>
                <div
                  className="order-track-text"
                  style={{ marginBottom: "20px" }}
                >
                  <p
                    className="order-track-text-stat"
                    style={{
                      color: "#3F3F3F",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    Прибыл в Астану{" "}
                    <span style={{ fontWeight: "normal" }}>02-27 15:44</span>
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default OrderTrackingLocationUI;